import * as React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"

const Tool = ({ image, title, subtitle, url }) => (
  <Link to={url}>
    <div className="max-w-sm rounded overflow-hidden shadow-lg">
      <Img fluid={image.childImageSharp.fluid} />
      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">{title}</div>
        <p className="text-gray-700 text-base">{subtitle}</p>
      </div>
      <div className="px-6 py-4">
        <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">
          #decision-making
        </span>
        <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">
          #long-term
        </span>
      </div>
    </div>
  </Link>
)

const Index = ({ data }) => {
  return (
    <React.Fragment>
      <Helmet title="Tools for thinker | Mental models in action" />
      <Layout
        headerTitle="Mental models in action. Assess your decisions"
        headerSubtitle="Improve your ability to make decisions over time"
      >
        <Tool
          image={data.second}
          url="/second-order-effect/"
          title="Second-order thinking"
          subtitle="Consider the long-term consequences of your decisions."
        />
      </Layout>
    </React.Fragment>
  )
}

export default Index

export const query = graphql`
  query {
    second: file(relativePath: { eq: "second-order.png" }) {
      childImageSharp {
        fluid(maxWidth: 900) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`
